import { Specs } from './experiments';

export const initNewWixFooter = (config, nodes) => {
  const newConfig = {
    target: nodes.footer,
    language: config.language,
    replaceTarget: true,
  };
  if (config.languagePickerList) {
    newConfig.languagePickerList = config.languagePickerList;
  }
  window.WixFooter.render(newConfig);
};

const isExcludedSite = () => {
  const excludedSiteList = ['wix.com/user-journey-chat-sidebar', 'wix.com/premium-manage-subscriptions'];
  return excludedSiteList.some(url => window.location.href.includes(url));
};

const NEW_FOOTER_LANGUAGES = ['en'];

export const shouldRenderNewWixFooter = (config, experiments) => {
  if (!config) {
    return false;
  }

  const isOnlyHeader = config.useOnly === 'header';
  const isExperimentEnabled = experiments[Specs.EnableNewWixFooter] === 'true';
  const isEnabledLanguage = NEW_FOOTER_LANGUAGES.includes(config.language);
  const isWixFooterApiExists = window.WixFooter && typeof window.WixFooter.render === 'function';

  let shouldRender = !isOnlyHeader && !isExcludedSite() && (isExperimentEnabled || isEnabledLanguage);

  if (shouldRender && !isWixFooterApiExists) {
    console.warn('Error getting init function of New Wix Footer');
    shouldRender = false;
  }

  return shouldRender;
};
